import parsePhoneNumber from "libphonenumber-js";

const normalizePhoneNumber = (phoneNumber: string): string => {
    const parsedNumber = parsePhoneNumber(phoneNumber);

    return parsedNumber ? parsedNumber.format('E.164') : phoneNumber;
};

export default normalizePhoneNumber;
